interface UserInfoKeyValuePair {
  [key: string]: any[] | undefined;
  valueList?: any[];
}

// I have been forced to do this. Forgive me :(
// Even if the client does not have a specific permission (api does not support / does not exist) or permission elements
// return an empty array so UI won't crash. 
export function getPermissions<T extends keyof UserInfoKeyValuePair>(userPermissions: { [K in T]?: any[] }, permissionKey: T): any[] {
  if (userPermissions.hasOwnProperty(permissionKey)) {
    return userPermissions?.[permissionKey] ?? [];
  } else {
    return [];
  }
}

//It's me again.. and sorry again.
//If the permisson group does not exist in the userpermission we assume it's because the API does not support it in that version.
export function shouldPermissionExist<T extends keyof UserInfoKeyValuePair>(userPermissions: { [K in T]?: any[] }, permissionKey: T): boolean {
  if (userPermissions.hasOwnProperty(permissionKey) && userPermissions?.[permissionKey]) {
    return true;
  } else {
    return false;
  }
}


//I don't know what I'm doing here and at this point I'm afraid to ask.
/**
 * If the permisson inside a permission group does not exist in the userpermission we assume it's because the API does not support it in that version.
 *
 * @param keyValuePair This is an object with keys of type T (which is a keyof UserPermissions). It represents the user's permissions.
 * @param groupKey This parameter represents the key of the permission group you want to check.
 * @param searchKey This parameter represents the specific permission you want to check within the permission group.
 * @returns true/false
 */
export function shouldValueListInUserInfoGroupExist<T extends keyof UserInfoKeyValuePair, E extends number>(
  keyValuePair: { [K in T]?: any[] },
  groupKey: T,
  searchKey: E 
): boolean {  
  if (keyValuePair?.hasOwnProperty(groupKey) && keyValuePair?.[groupKey]?.includes(searchKey)) {
    return true;
  } else {
    return false;
  }
}